function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconImageRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 27h24V5H4v22zM28 3H4a2 2 0 00-2 2v22a2 2 0 002 2h24a2 2 0 002-2V5a2 2 0 00-2-2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 14a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9h16v9.578l-3.555-3.555-3 2.999-5-4.999L8 17.468V9zm0 14v-2.704l4.445-4.445 6.128 6.128 1.414-1.414-1.128-1.127 1.586-1.586L24 21.406V23H8zm-2 2h20V7H6v18z",
    fill: props.color
  }));
}

export default SvgIconImageRexOutline;